/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lime_Brave_Meerkat_GraceInputs */

const fr_lime_brave_meerkat_grace = /** @type {(inputs: Lime_Brave_Meerkat_GraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalise le contenu affiché sur la homepage.`)
};

/**

* @param {Lime_Brave_Meerkat_GraceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lime_brave_meerkat_grace = /** @type {((inputs?: Lime_Brave_Meerkat_GraceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lime_Brave_Meerkat_GraceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lime_brave_meerkat_grace(inputs)
});